export default "__VITE_ASSET__CyG4oUz4__"